import { useEffect, useRef, useState } from 'react';

export const usePageOffset = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const updateOffset = () => {
      if (ref.current) {
        const computedStyle = window.getComputedStyle(ref.current);
        const bottomValue = parseFloat(computedStyle.bottom);

        setOffset(ref.current.offsetHeight + bottomValue + 20 - 50);
      }
    };

    updateOffset();

    window.addEventListener('resize', updateOffset);
    window.addEventListener('scroll', updateOffset);

    return () => {
      window.removeEventListener('resize', updateOffset);
      window.removeEventListener('scroll', updateOffset);
    };
  }, []);

  return { ref, offset };
};
